<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <span class="font-size-16 fw-bold">{{ title | uppercase }}</span>
      <div class="page-title-right">
        <ol class="breadcrumb m-0">
          <ng-container *ngFor="let item of breadcrumbItems">
            <li class="breadcrumb-item fw-medium" *ngIf="!item.active"><a class="enablePointer" (click)="route(item.href)">{{ item.label | translate }}</a>
            </li>
            <li class="breadcrumb-item active fw-medium" *ngIf="item.active">{{ item.label | translate }}
            </li>
          </ng-container>
        </ol>
      </div>
    </div>
  </div>
</div>
